export default {
    badgeList: {},
};
  
